import React, { useState, useEffect } from 'react';
import axios from 'axios';

const Carousel = () => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [data, setData] = useState([]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.get("https://laravel-api.aj-mart.com/api/banners");
        const filteredBanners = response.data.banners.filter(banner => banner.banner_landing_image !== null);
        setData(filteredBanners);
      }
      catch (error) {
        console.error("Error When Fetch Brands : ", error);
      }
    }
    fetchData();
  }, []);

  const prevSlide = () => {
    setCurrentIndex((prevIndex) =>
      prevIndex === 0 ? data.length - 1 : prevIndex - 1
    );
  };

  const nextSlide = () => {
    setCurrentIndex((prevIndex) =>
      prevIndex === data.length - 1 ? 0 : prevIndex + 1
    );
  };

  useEffect(() => {
    const autoplay = setInterval(() => {
      nextSlide();
    }, 2000);
    return () => clearInterval(autoplay);
  }, [currentIndex]);

  return (
    <div className="relative w-full overflow-hidden">
      <div
        className="flex transition-transform duration-700"
        style={{ transform: `translateX(-${currentIndex * 100}%)` }}
      >
        {data.map((el) => (
          <div key={el.id} className="w-full flex-shrink-0">
            <img
              className="hv-25 w-full h-[50vh] object-cover"
              src={`https://laravel-api.aj-mart.com/storage/app/public/${el.banner_landing_image}`}
              alt={`Banner ${el.id + 1}`}
            />
          </div>
        ))}
      </div>

      <button
        onClick={prevSlide}
        className="wh-30 absolute top-1/2 left-4 transform -translate-y-1/2 bg-[#1485a6] w-[35px] h-[35px] flex items-center justify-center text-white rounded-full p-2 hover:bg-[#0387c1]"
      >
        ❮
      </button>
      <button
        onClick={nextSlide}
        className="wh-30 absolute top-1/2 right-4 transform -translate-y-1/2 bg-[#1485a6] w-[35px] h-[35px] flex items-center justify-center text-white rounded-full p-2 hover:bg-[#0387c1]"
      >
        ❯
      </button>

      <div className="d-none absolute bottom-4 left-1/2 transform -translate-x-1/2 flex space-x-2">
        {data.map((_, index) => (
          <div
            key={index}
            onClick={() => setCurrentIndex(index)}
            className={`w-3 h-3 rounded-full cursor-pointer ${index === currentIndex ? 'bg-[#1485a6]' : 'bg-[#666666]'}`}
          ></div>
        ))}
      </div>
    </div>
  );
};

export default Carousel;
